import {Frontend} from "./frontend";

(function () {
    XonBoard.Units = {
        list: {

            selectors: {
                units_table: $('#units-table'),
                count_label: $('#count-label'),
            },

            init: function () {

                let self = this;
                let table = this.selectors.units_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.units_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsFiltered);
                            return json.data;
                        }
                    },
                    columns: [
                        {
                            data: 'name',
                            name: 'units.name',
                            render: (name, type, item) => item.address ? `<div>${name}</div><div class="text-xs text-grey5">${$('<div>').text(item.address).html()}</div>` : name
                        },
                        {
                            data: 'latitude',
                            name: 'units.latitude',
                            searchable: false,
                            sortable: false,
                            render: (latitude, type, unit) => XonBoard.Map.locationCell(latitude, unit.longitude)
                        },
                        {data: 'building_name', name: 'buildings.name'},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false}
                    ],
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
        },

        edit: {
            selectors: {},

            init: function (locale) {
                this.addHandlers(locale);
                XonBoard.tinyMCE.init(locale);
            },

            addHandlers: function (locale) {
            },
        },
    }
})();
